module.exports = __webpack_public_path__ + "img/photos/sla02a.jpg";